import * as React from 'react';
import { Layout, Notification, Cell } from 'wix-style-react';
import { composer } from '../../../component-decorators/composer';
export var MarketingIntegrationsToast = composer()
    .withExperiments()
    .withTranslation()
    .compose(function (_a) {
    var t = _a.t, navigateToMarketingIntegration = _a.navigateToMarketingIntegration;
    return (React.createElement(Layout, null,
        React.createElement(Cell, null,
            React.createElement(Notification, { show: true },
                React.createElement(Notification.TextLabel, null, t('manage-apps.marketing-integrations-toast.done')),
                React.createElement(Notification.ActionButton, { onClick: function () { return navigateToMarketingIntegration(); } }, t('manage-apps.marketing-integrations-toast.back')),
                React.createElement(Notification.CloseButton, null)))));
});
//# sourceMappingURL=marketing-integrations-toast.js.map